<template>
  <div class="df fdc">
    <h2>Forbidden</h2>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
  data () {
    return {
      email: ''
    }
  },
  props: [],
  components: {

  },
  methods: {
  },
  computed: {

  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>

<style scoped lang="scss">
  h2 {
    color: black;
    font-weight: 500;
    margin-bottom: 30px;
    align-self: center;

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      font-size: 16px;
    }
  }

.forgot-password {
  color: #0874D8;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 20px;
}

.show-password-wrapper {
  position: relative;
}

.show-password {
  position: absolute;
  right: 8px;
  top: 8px;
  color: #2C74DC;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.21px;
  line-height: 14px;
}
</style>
